import { RETURNURL_STORAGE_KEY } from './consts';
export var EMPTY_RETURNURL = '{ "queries": {} }';
export function getReturnURLFromStorage() {
    return JSON.parse(sessionStorage.getItem(RETURNURL_STORAGE_KEY) || EMPTY_RETURNURL);
}
//# sourceMappingURL=getReturnURLFromStorage.js.map